export default "__VITE_ASSET__CFaAC58J__"